module.exports = __webpack_public_path__ + "static/img/svc-rights-print.2c72a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svc-rights-print.png
// module id = UVtr
// module chunks = 0